export default "\r\n<app-generic-list></app-generic-list>\r\n\r\n\r\n";